import React, { useState } from 'react';
import classNames from 'classnames';
import { reportName } from '../../helpers/reportNames';
import { Link } from 'react-router-dom';
import SpinnerDots from '../spinner/dots';
import Takeover from '../takeover';
import { Button } from '../forms';
import './report-header.scss';

const Parameter = props => {

    let defaultValue = (props.selectedValues && props.selectedValues[0]) ? props.selectedValues[0] : '';

    if (!defaultValue && props.validValues[0] && defaultValue !== '') {
        props.onChange({...props, selectedValues: [props.validValues[0].value]});
    }
    
    return (
        <label className="report-header__label">
            <select className="form__select report-header__select" value={defaultValue} onChange={(e) => {
                props.onChange({...props, selectedValues: [e.currentTarget.value]});
            }}>
                <option value="">Välj {props.label.toLowerCase()}</option>
                {props.validValues.map((item, i) => {
                    return (
                        <option key={`${item.value}${i}`} value={item.value}>{item.value === 'True' || item.value === 'False' ? props.name : null} {item.name}</option>
                    );
                })}
            </select>
        </label>
        
    );
};

const ReportHeader = props => {
    const [isTakeover, toggleTakeover] = useState(false);


    const isDisabled = () => {
        if (!props.report) return true;

        if (!props.report.parameters) return true;

        if (props.report.parameters.find(param => param.selectedValues[0] === '')) return true;

        return false;
    };

    const getButtonText = () => {

        if (props.isLoadingReport) {
            return 'Laddar rapport';
        }

        if (props.isLoadingPeriods) {
            return 'Laddar';
        }

        return 'Visa rapport';
    };

    return (
        <>
            <header className={classNames({
                'report-header': true,
                'report-header--breadcrumb': true,
                'report-header--is-loading-report': props.isLoadingReport,
                'report-header--is-loading-periods': props.isLoadingPeriods,
                'report-header--is-loading': props.isLoading
            })}>
                <div className="report-header__content">
                    <section className="breadcrumb breadcrumb--min-padding">
                        <Link className="breadcrumb__item" title="Alla grenar" to="/company">Alla grenar</Link>
                    </section>
                    <h1 className="report-header__heading"><span>{props.report && props.report.branchName}&nbsp;</span></h1>
                </div>

                <div className="report-header__controls">
                    {(props.report && props.report.additionalInfo && props.report.additionalInfo.definitionFile) &&
                        <button type="button" className="report-header__link" onClick={(e) => {
                            e.preventDefault(); toggleTakeover(true);
                        }}><span>Definitioner</span></button>
                    }
                    <span className="report-header__controls-type"><span><strong>Typ:&nbsp;</strong> <span className="report-header__type-value">{props.report && reportName(props.report.reportType)}</span></span></span>
                    {props.report && props.report.parameters && props.report.parameters.map((parameter, i) => {
                        return (
                            <Parameter key={`parameter-${i}`} {...parameter} onChange={(obj) => props.handleParameterChange(obj)} />
                        );
                    })}
                    <button type="button" 
                            className="form__button report-header__button" 
                            onClick={() => props.loadReport()}
                            disabled={isDisabled()}>
                        <SpinnerDots />
                        {getButtonText()}
                    </button>
                </div>
            </header>
            <Takeover isOpen={isTakeover} toggleTakeover={() => toggleTakeover(false)} heading="Definitioner">
                {(props.report && props.report.additionalInfo) &&
                    <>
                        <p>{props.report.additionalInfo.definition}</p>
                        <p>
                            <a href={props.report.additionalInfo.definitionFileUrl} target="_blank" rel="noreferrer">Ladda hem definitioner</a>
                        </p>
                        {props.report.additionalInfo.companies &&
                            <>
                                <h2>Företag i gren ({props.report.additionalInfo.companies.length})</h2>
                                <ul>
                                {props.report.additionalInfo.companies.map(company => {
                                    return <li key={company.id}>{company.name}</li>
                                })}                                 
                                </ul>
                            </>
                        }
                        <div className="statstics-list__takeover-footer">
                            <Button type="button" 
                                    modifiers={{
                                        'form__button--muted': true,
                                        'form__button--centered': true
                                    }}
                                    onClick={() => toggleTakeover(!isTakeover)}>Stäng</Button>
                        </div>
                    </>
                }
            </Takeover>
        </>
    );
};

export default ReportHeader;